
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface PortfolioUrlSectionProps {
  portfolioUrl: string;
  onPortfolioUrlChange: (value: string) => void;
}

const PortfolioUrlSection = ({ 
  portfolioUrl, 
  onPortfolioUrlChange 
}: PortfolioUrlSectionProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="portfolio_url">Portfolio URL</Label>
      <Input
        id="portfolio_url"
        placeholder="e.g., https://myportfolio.com"
        value={portfolioUrl}
        onChange={(e) => onPortfolioUrlChange(e.target.value)}
      />
      <p className="text-sm text-muted-foreground">
        Add a link to your personal website or portfolio.
      </p>
    </div>
  );
};

export default PortfolioUrlSection;
